import { Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FeedbackPage } from '@/pages/FeedbackPage';
import { OfflinePage } from '@/pages/OfflinePage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { Toaster } from '@/components/ui/toaster';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { isRTL } from './i18n';

/**
 * Loading fallback for i18n
 */
function LoadingFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-canvas">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
    </div>
  );
}

/**
 * Main app content with RTL support
 */
function AppContent() {
  const { i18n } = useTranslation();
  const dir = isRTL(i18n.language) ? 'rtl' : 'ltr';

  return (
    <div dir={dir} className="min-h-screen">
      <Toaster />
      <Routes>
        {/* Feedback form - accessed via QR code */}
        <Route path="/:qrCode" element={<FeedbackPage />} />

        {/* Offline fallback */}
        <Route path="/offline" element={<OfflinePage />} />

        {/* Landing/Not found - instructs user to scan QR */}
        <Route path="/" element={<NotFoundPage />} />
      </Routes>
    </div>
  );
}

/**
 * App wrapper with BrowserRouter and i18n Suspense
 */
function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Suspense fallback={<LoadingFallback />}>
          <AppContent />
        </Suspense>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
